import { useFiles } from 'client/store'
import { getFileById } from 'client/store/files/filesSelectors'
import { BackgroundInterface } from 'common/types/background-interfaces'
import { getMobileBackgroundFileId } from 'common/utils/getMobileBackgroundFileId'

interface UseBackgroundImageInterface {
  backgroundFileId: BackgroundInterface['backgroundFileId']
  mobileBackgroundFileId: BackgroundInterface['backgroundFileId']
}

export const useBackgroundImage = ({
  backgroundFileId,
  mobileBackgroundFileId,
}: UseBackgroundImageInterface) => {
  const backgroundFile = useFiles(state => getFileById(state, backgroundFileId))

  const mobileBackgroundFile = useFiles(state =>
    getFileById(
      state,
      getMobileBackgroundFileId(backgroundFileId, mobileBackgroundFileId),
    ),
  )

  const backgroundImage = backgroundFile
    ? `url("${backgroundFile.path}")`
    : 'none'

  const mobileBackgroundImage = mobileBackgroundFile?.path
    ? `url("${mobileBackgroundFile.path}")`
    : 'none'

  return { backgroundImage, mobileBackgroundImage }
}
